import React from 'react'

const Title = ({ className = '', ...args }) => (
  <h1 className={className + ' page-title'} {...args} />
)

export default Title
